// File for logic corresponding to homepage component
import { Component } from 'js-component-framework';

// Checks for sections that shouldn't be included in alternating backgrounds.
function excludedSection(section) {
  const classes = section.classList.value;
  return classes.indexOf('bass-component__ad-container') > -1
    || classes.indexOf('wp-block-spacer') > -1;
}

// Checks for featured sections (which always have a white background).
function featuredSection(section) {
  return section.classList.value.indexOf('bass-component__featured') > -1;
}

/**
 * Component for:
 * - site homepage alternating background colors
 * - "close the sticky leaderboard" button on mobile.
 */
export default class Homepage extends Component {
  /**
   * Start the component
   */
  constructor(config) {
    super(config);
    // Get all homepage top-level sections (blocks).
    const homepageSections = document.querySelectorAll('section, .bass-component__ad-container, .bass-component__aoy-leaderboard');

    // Keep track to alternate background color.
    let alternator = 1;

    // Iterate through blocks and apply background class.
    homepageSections.forEach((section) => {
      // If section should be included in alternated background colors.
      if (!excludedSection(section)) {
        // If not a featured section (always white), apply background color if appropriate.
        if (alternator && !featuredSection(section)) {
          section.classList.add('homepage-background-color');
          alternator = 0;
        } else {
          alternator = 1;
        }
      }
    });

    // For mobile screens only.
    if (window.innerWidth < 768) {
      setTimeout(() => {
        // Get leaderboard ad.
        const leaderboard = document.querySelector('.top-leaderboard');

        // If there isn't a leaderboard or tourny nav bail.
        if (!leaderboard) {
          return;
        }

        // Add a dismiss button.
        const button = document.createElement('button');
        button.innerHTML = 'x';
        leaderboard.appendChild(button);
        button.addEventListener('click', (e) => {
          e.preventDefault();
          leaderboard.style.display = 'none';
        });
      }, 200); // Slight delay to allow DOM to render.
    }
  }
}
